// emblaCarouselDotButtons.js

export const addDotButtonAndClickHandlers = (emblaApi, dotsNodes) => {
  // dotsNodes: NodeList of .embla__dots, one inside every slide
  const containers = Array.from(dotsNodes)
  let dotsPerContainer = []

  const addDotBtnsWithClickHandlers = () => {
    const snapCount = emblaApi.snapList().length

    dotsPerContainer = containers.map((container) => {
      container.innerHTML = ''

      // Nothing to navigate with a single snap
      if (snapCount < 2) return []

      return Array.from({ length: snapCount }, (_, index) => {
        const dot = document.createElement('button')
        dot.type = 'button'
        dot.className = 'embla__dot'
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1))
        dot.addEventListener('click', () => emblaApi.goTo(index), false)
        container.appendChild(dot)
        return dot
      })
    })
  }

  const toggleDotButtonsActive = () => {
    const selected = emblaApi.selectedSnap()

    dotsPerContainer.forEach((dots) => {
      dots.forEach((dot, index) => {
        dot.classList.toggle('embla__dot--selected', index === selected)
      })
    })
  }

  addDotBtnsWithClickHandlers()
  toggleDotButtonsActive()

  emblaApi
    .on('reinit', addDotBtnsWithClickHandlers)
    .on('reinit', toggleDotButtonsActive)
    .on('select', toggleDotButtonsActive)
}
